module.exports = __webpack_public_path__ + "plane-pc/img/map.3141e4d6.png";